/**
 * @desc 通过线下销售单号获取线下销售单信息
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(
  params: API.business.customerOrderFacadeImpl.getByBoOrderNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/customerOrder/getByBoOrderNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
